<template>
  <div>
    <Card class="mb-3">
      <template #content>
        <NewsFilter
          v-model:selected-organization-id="selectedOrganizationId"
          v-model:selected-for-members="selectedForMembers"
          v-model:selected-news-label="selectedNewsLabel"
          :organizations="joinOrganizations"
          :news-filter-options="newsFilterOptions"
          :news-labels="newsLabels"
          viewmode
        />
      </template>
    </Card>

    <Card>
      <template #content>
        <div class="d-flex justify-content-center w-100">
          <div class="w-100">
            <span
              v-if="filteredNews && !filteredNews.length"
              class="text-danger"
              >お知らせがありません</span
            >
            <NewsTable
              v-else-if="filteredNews"
              :news="filteredNews"
              viewmode
              @select-news="handleSelectNews"
            />
            <i v-else class="pi pi-spin pi-spinner"></i>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { getStorage, setStorage } from "/@/modules/localStorage";
import {
  Table as NewsTable,
  Filter as NewsFilter,
} from "/@/vue/components/Organisms/Users/News";
import { useRouterUtil, useUser, useNews } from "/@/vue/composables";
import { newsLabels } from "/@/types";
import Card from "primevue/card";

const { goto } = useRouterUtil();

// api

const {
  getUsersNews,
  trashNews,
  selectedNewsLabel,
  selectedForMembers,
  newsFilterOptions,
  newsFilter,
} = useNews();

const { getUser } = useUser();
const { data: user } = getUser({
  withMemberAnnounces: true,
});

const memberAnnounces = computed(() => {
  if (!user.value) return [];

  return user.value.memberAnnounces || [];
});

const filteredNews = computed(() => {
  if (!memberAnnounces.value) return [];

  return newsFilter(
    memberAnnounces.value,
    selectedNewsLabel.value,
    selectedForMembers.value,
    selectedOrganizationId.value
  );
});

const joinOrganizations = computed(() => {
  if (!user.value) return [];

  return user.value.joinOrganizations;
});

const managedOrganizations = computed(() => {
  if (!user.value) return [];

  return user.value.managedOrganizations;
});

const selectedOrganizationId = ref(
  getStorage("selectedOrganizationId") || undefined
);

watch(managedOrganizations, (os) => {
  if (!os) return;

  if (os.some((o) => o.id === selectedOrganizationId.value)) {
    return;
  }

  selectedOrganizationId.value = os[0]?.id;
});

watch(selectedOrganizationId, (id) => {
  if (!id) return;
  setStorage("selectedOrganizationId", id);
});

watch(user, (u) => {
  if (!u || !!selectedOrganizationId.value) return;

  selectedOrganizationId.value = u.managedOrganizations[0]?.id;
});

function handleSelectNews(id: number) {
  goto({ name: "UsersNewsUserNewsShow", params: { id: id } });
}

function selectNews(id: number) {
  goto({ name: "UsersNewsShow", params: { id: id } });
}
</script>

<style lang="scss" scoped></style>
